import { realEstate } from 'fetchers/realEstateApi';
import { atom, selector } from 'recoil';

export const aptIdSelector = selector({
  key: 'aptId',
  get: async () => {
    const {
      apt: { id },
    } = await realEstate.getAptInfo();
    return id;
  },
});

export const userIdSelector = selector({
  key: 'userLevel',
  get: async () => {
    const user_id = window.localStorage.getItem('user_id');
    if (user_id) return user_id;
  },
});

export const selectLive = atom({
  key: 'selectLive',
  default: 'm',
});

export const selectSize = atom({
  key: 'selectSize',
  default: '',
});

export const selectTab = atom({
  key: 'selectTab',
  default: 'recent',
});

export const modalState = atom({
  key: 'modalState',
  default: { state: false, type: '' },
});

export const currentRealEstateData = atom({
  key: 'realEstateData',
  default: [],
});

export const realEstateModalState = atom({
  key: 'realEstateModalState',
  default: false,
});

export const aptInfoDataList = atom({
  key: 'aptInfo',
  default: [],
});

export const recentDataList = atom({
  key: 'recentData',
  default: [],
});

export const chartDataList = atom({
  key: 'chartData',
  default: [],
});

export const loadingState = atom({
  key: 'loading',
  default: true,
});

export const currentModalData = atom({
  key: 'currentModalData',
  default: [],
});

export const currentInnerWidth = atom({
  key: 'currentInnerWidth',
  default: window.innerWidth,
});
